import { Component, OnInit,ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
   encapsulation: ViewEncapsulation.None
})
export class HomeComponent implements OnInit {
  showMaster = false;
  showEmployees = false;
  isMasterExpanded = false;
isEmployeeExpanded = false;

  toggleMaster() {
    this.showMaster = !this.showMaster;
  }

  toggleEmployees() {
    this.showEmployees = !this.showEmployees;
  }
  constructor(public router:Router) { }
logout(){
  this.router.navigate(["/login"]);
}
  ngOnInit(): void {
  }

}
